/* eslint-disable no-debugger */
import React from "react";
import { withTranslation } from "react-i18next";
import { Dropdown, TextInput, CustomCheckBox, Image } from "hesus-ui-kit";
import { range } from "lodash";
import PropTypes from "prop-types";
import BarLoader from "react-spinners/BarLoader";
import { Tooltip } from "react-tooltip";
import blueArrowIcon from "@icons/arrow-blue-ic.svg";
import orangeArrowIcon from "@icons/arrow-orange-ic.svg";
import { priceTypes } from "@utils/constants";
import { renderPriceWithCurrency } from "@utils/utils";
import enableIcon from "@icons/ic-enable.svg";
import disableIcon from "@icons/ic-disable.svg";
import {
  PriceContainer,
  PricePerUnit,
  GridRow,
} from "../ServiceTypeCondition/ServiceTypeCondition.styled";
import {
  labelStyles,
  inputStyles,
  labelStylesError,
  inputStylesError,
} from "@utils/extra-style";
import "../../AddEditSellingPrice.scss";
import {
  Title,
  SolutionListItem,
  SolutionListItemTitleWrapper,
  SolutionListItemTitle,
  SolutionListItemPriceWrapper,
  SolutionListItemPrice,
  SolutionListItemPriceLabel,
  SolutionListItemPriceValue,
  SolutionListItemOuter,
  UnitPriceInput,
  GridOuterPriceType,
  AllocationParent,
  AllocationQuantity,
  RequiredMessagePara,
  PurchasePriceValue,
  EstimatedPurchasePriceLabel,
  GridPurchasePriceType,
  NoSolutionOuter,
  NoSolution,
  ToggleGridOuter,
  SolutionToggleLabel,
  UppEmpty,
  CommentText,
  ToolTipCommentText,
  ToolTipCommentsWrapper,
  DivToolTipCustom,
} from "./SolutionListing.styled";

const SolutionListing = ({
  t,
  isEditMode,
  isDisabled,
  serviceData,
  onSellingPriceSolutionChange,
  hesusCatalogServiceId,
  hesusServiceId,
  catalogServiceIdSolutionApi,
  currency,
  currencyPosition,
  onChange,
  countryNeedSolution,
  exchangeRate,
  currencyId,
}) => {
  const colorOfBox = (type, serviceInfo) => {
    let color = "#767676";
    if (
      serviceInfo.needProduct &&
      !serviceInfo.needTransport &&
      type === "TREATMENT"
    )
      color = "#474747";
    else if (
      !serviceInfo.needProduct &&
      serviceInfo.needTransport &&
      type === "TRANSPORT"
    )
      color = "#474747";
    else if (
      serviceInfo.needProduct &&
      serviceInfo.needTransport &&
      (type === "TRANSPORT" || type === "TREATMENT")
    )
      color = "#474747";

    return color;
  };

  const checkDisabledcheckBoxStatus = (
    needProduct,
    needTransport,
    combinationId
  ) => {
    if (combinationId) {
      if (needProduct && (!needTransport || needTransport === 0)) {
        return false;
      }
      return true;
    }
    return false;
  };

  const checkDisabledStatausOfAllocation = (
    needProduct,
    needTransport,
    combinationId
  ) => {
    if (isDisabled) return isDisabled;
    if (combinationId) {
      if (!isDisabled) {
        if (needProduct && (!needTransport || needTransport === 0)) {
          return false;
        }
        return true;
      }
    }
    return isDisabled;
  };

  return (
    <>
      <Title>{t("SELLING_PRICE_CREATION_POP_UP_MATCHINGS_TITLE")}</Title>
      {catalogServiceIdSolutionApi.indexOf(
        parseInt(hesusCatalogServiceId, 10)
      ) !== -1 && <BarLoader width="100%" color="#1bace4" />}
      {catalogServiceIdSolutionApi.indexOf(
        parseInt(hesusCatalogServiceId, 10)
      ) === -1 && (
        <SolutionListItemOuter>
          {serviceData.serviceField.solutionList.value.length > 0 &&
            serviceData.serviceField.solutionList.value.map((solutionItem) => {
              return (
                <SolutionListItem key={solutionItem.id}>
                  <SolutionListItemTitleWrapper>
                    <div>
                      <CustomCheckBox
                        id={`selling-price-solution-${
                          parseInt(hesusCatalogServiceId) +
                          "_" +
                          parseInt(solutionItem.id, 10)
                        }`}
                        name={
                          parseInt(hesusCatalogServiceId) +
                          "_" +
                          parseInt(solutionItem.id, 10)
                        }
                        dataId={
                          parseInt(hesusCatalogServiceId) +
                          "_" +
                          parseInt(solutionItem.id, 10)
                        }
                        onChange={(e) => {
                          onSellingPriceSolutionChange(
                            e,
                            solutionItem.id,
                            hesusCatalogServiceId,
                            hesusServiceId,
                            "solution"
                          );
                        }}
                        checked={solutionItem?.isSelected}
                        disabled={checkDisabledcheckBoxStatus(
                          serviceData.hesusServiceInfo.needProduct,
                          serviceData.hesusServiceInfo.needTransport,
                          serviceData.hesusCatalogServiceCombination
                        )}
                      />
                      <SolutionListItemTitle>
                        #{solutionItem.id ?? ""} -{" "}
                        {solutionItem.priceType === 3 &&
                          solutionItem.haulier?.companyName}
                        {solutionItem.priceType !== 3 && (
                          <>
                            [
                            {solutionItem.centre?.supplierName
                              ? solutionItem.centre?.supplierName
                              : ""}
                            {solutionItem.centre?.companyName
                              ? " - " + solutionItem.centre?.companyName
                              : ""}
                            ] {solutionItem.centreProduct?.product?.name ?? ""}
                            {solutionItem.centreProduct?.label
                              ? " - " + solutionItem.centreProduct?.label
                              : ""}
                          </>
                        )}
                      </SolutionListItemTitle>
                    </div>
                  </SolutionListItemTitleWrapper>
                  <GridOuterPriceType>
                    <div>
                      {(solutionItem.priceType ===
                        priceTypes.TransportTreatmentSeparated ||
                        solutionItem.priceType ===
                          priceTypes.TreatmentOnly) && (
                        <SolutionListItemPriceWrapper>
                          <SolutionListItemPrice>
                            <SolutionListItemPriceLabel
                              color={colorOfBox(
                                "TREATMENT",
                                serviceData.hesusServiceInfo
                              )}
                            >
                              {t("TREATMENT")}
                            </SolutionListItemPriceLabel>
                            <SolutionListItemPriceValue
                              textAlign="right"
                              color={colorOfBox(
                                "TREATMENT",
                                serviceData.hesusServiceInfo
                              )}
                            >
                              {renderPriceWithCurrency(
                                solutionItem.solutionTreatmentPrice?.price ??
                                  "",
                                t(solutionItem.solutionTreatmentPrice.unit),
                                solutionItem.solutionTreatmentPrice.currency
                                  ?.symbol,
                                solutionItem.solutionTreatmentPrice.currency
                                  ?.position
                              )}
                            </SolutionListItemPriceValue>
                            {serviceData.hesusServiceInfo.needProduct &&
                              !serviceData.hesusServiceInfo.needTransport && (
                                <>
                                  {!solutionItem.calculatedUnitPurchasePrice
                                    ?.errors && (
                                    <SolutionListItemPriceValue color="#008395">
                                      {parseInt(currencyId, 10) ===
                                        parseInt(
                                          solutionItem.solutionTreatmentPrice
                                            .currency.id,
                                          10
                                        ) && (
                                        <>
                                          <Image
                                            src={blueArrowIcon}
                                            className="addd-edit-selling-price__image-small-icon"
                                          />
                                          {renderPriceWithCurrency(
                                            solutionItem
                                              .calculatedUnitPurchasePrice
                                              ?.treatment?.price,
                                            t(
                                              solutionItem
                                                .calculatedUnitPurchasePrice
                                                ?.treatment?.unit
                                            ),
                                            currency,
                                            currencyPosition
                                          )}
                                        </>
                                      )}
                                      {parseInt(currencyId, 10) !==
                                        parseInt(
                                          solutionItem.solutionTreatmentPrice
                                            .currency.id,
                                          10
                                        ) &&
                                        exchangeRate.find(
                                          (rate) =>
                                            rate.id ===
                                              solutionItem
                                                .solutionTreatmentPrice.currency
                                                .id && rate.rate !== ""
                                        ) && (
                                          <>
                                            <Image
                                              src={blueArrowIcon}
                                              className="addd-edit-selling-price__image-small-icon"
                                            />
                                            {renderPriceWithCurrency(
                                              solutionItem
                                                .calculatedUnitPurchasePrice
                                                ?.treatment?.price,
                                              t(
                                                solutionItem
                                                  .calculatedUnitPurchasePrice
                                                  ?.treatment?.unit
                                              ),
                                              currency,
                                              currencyPosition
                                            )}
                                          </>
                                        )}
                                      {((parseInt(currencyId, 10) !==
                                        parseInt(
                                          solutionItem.solutionTreatmentPrice
                                            .currency.id,
                                          10
                                        ) &&
                                        !exchangeRate.find(
                                          (rate) =>
                                            rate.id ===
                                              solutionItem
                                                .solutionTreatmentPrice.currency
                                                .id && rate.rate !== ""
                                        )) ||
                                        solutionItem.calculatedUnitPurchasePrice
                                          ?.treatment.error) && (
                                        <UppEmpty>
                                          <Image
                                            src={orangeArrowIcon}
                                            className="addd-edit-selling-price__image-small-icon"
                                          />
                                          {"-- " +
                                            currency +
                                            "/" +
                                            t(
                                              solutionItem
                                                .solutionTreatmentPrice?.unit
                                            )}
                                        </UppEmpty>
                                      )}
                                    </SolutionListItemPriceValue>
                                  )}
                                  {solutionItem.calculatedUnitPurchasePrice
                                    ?.errors && (
                                    <SolutionListItemPriceValue color="#ff981e">
                                      <Image
                                        src={orangeArrowIcon}
                                        className="addd-edit-selling-price__image-small-icon"
                                      />
                                      <UnitPriceInput
                                        type="text"
                                        value={
                                          solutionItem.solution
                                            ?.unitPurchasePrice?.treatment
                                            ?.price
                                        }
                                        onChange={(e) => {
                                          onSellingPriceSolutionChange(
                                            e,
                                            solutionItem.id,
                                            hesusCatalogServiceId,
                                            hesusServiceId,
                                            "upp",
                                            "treatment"
                                          );
                                        }}
                                      />{" "}
                                      {currency +
                                        "  /" +
                                        t(serviceData.serviceField.unit.value)}
                                      {solutionItem.solution?.unitPurchasePrice
                                        ?.treatment?.error && (
                                        <RequiredMessagePara>
                                          {
                                            solutionItem.solution
                                              ?.unitPurchasePrice?.treatment
                                              ?.error
                                          }
                                        </RequiredMessagePara>
                                      )}
                                    </SolutionListItemPriceValue>
                                  )}
                                </>
                              )}
                          </SolutionListItemPrice>
                        </SolutionListItemPriceWrapper>
                      )}

                      {(solutionItem.priceType ===
                        priceTypes.TransportTreatmentSeparated ||
                        solutionItem.priceType ===
                          priceTypes.TransportOnly) && (
                        <SolutionListItemPriceWrapper>
                          <SolutionListItemPrice>
                            <SolutionListItemPriceLabel
                              color={colorOfBox(
                                "TRANSPORT",
                                serviceData.hesusServiceInfo
                              )}
                            >
                              {t("TRANSPORT")} -{" "}
                              <SolutionListItemPriceValue fontStyle="italic">
                                {
                                  solutionItem.solutionTransportPrice
                                    ?.transportType?.name
                                }
                              </SolutionListItemPriceValue>
                            </SolutionListItemPriceLabel>

                            <SolutionListItemPriceValue
                              textAlign="right"
                              color={colorOfBox(
                                "TRANSPORT",
                                serviceData.hesusServiceInfo
                              )}
                            >
                              {renderPriceWithCurrency(
                                solutionItem.solutionTransportPrice?.price ??
                                  "",
                                t(solutionItem.solutionTransportPrice.unit),
                                solutionItem.solutionTransportPrice.currency
                                  ?.symbol,
                                solutionItem.solutionTransportPrice.currency
                                  ?.position
                              )}
                            </SolutionListItemPriceValue>
                            {!serviceData.hesusServiceInfo.needProduct &&
                              serviceData.hesusServiceInfo.needTransport && (
                                <>
                                  {!solutionItem.calculatedUnitPurchasePrice
                                    ?.errors && (
                                    <SolutionListItemPriceValue color="#008395">
                                      {parseInt(currencyId, 10) ===
                                        parseInt(
                                          solutionItem.solutionTransportPrice
                                            .currency.id,
                                          10
                                        ) && (
                                        <>
                                          <Image
                                            src={blueArrowIcon}
                                            className="addd-edit-selling-price__image-small-icon"
                                          />
                                          {renderPriceWithCurrency(
                                            solutionItem
                                              .calculatedUnitPurchasePrice
                                              ?.transport?.price,
                                            t(
                                              solutionItem
                                                .calculatedUnitPurchasePrice
                                                ?.transport?.unit
                                            ),
                                            currency,
                                            currencyPosition
                                          )}
                                        </>
                                      )}
                                      {parseInt(currencyId, 10) !==
                                        parseInt(
                                          solutionItem.solutionTransportPrice
                                            .currency.id,
                                          10
                                        ) &&
                                        exchangeRate.find(
                                          (rate) =>
                                            rate.id ===
                                              solutionItem
                                                .solutionTransportPrice.currency
                                                .id && rate.rate !== ""
                                        ) && (
                                          <>
                                            <Image
                                              src={blueArrowIcon}
                                              className="addd-edit-selling-price__image-small-icon"
                                            />
                                            {renderPriceWithCurrency(
                                              solutionItem
                                                .calculatedUnitPurchasePrice
                                                ?.transport?.price,
                                              t(
                                                solutionItem
                                                  .calculatedUnitPurchasePrice
                                                  ?.transport?.unit
                                              ),
                                              currency,
                                              currencyPosition
                                            )}
                                          </>
                                        )}
                                      {((parseInt(currencyId, 10) !==
                                        parseInt(
                                          solutionItem.solutionTransportPrice
                                            .currency.id,
                                          10
                                        ) &&
                                        !exchangeRate.find(
                                          (rate) =>
                                            rate.id ===
                                              solutionItem
                                                .solutionTransportPrice.currency
                                                .id && rate.rate !== ""
                                        )) ||
                                        solutionItem.calculatedUnitPurchasePrice
                                          ?.transport?.error) && (
                                        <UppEmpty>
                                          <Image
                                            src={orangeArrowIcon}
                                            className="addd-edit-selling-price__image-small-icon"
                                          />
                                          {"-- " +
                                            currency +
                                            " /" +
                                            t(
                                              solutionItem
                                                .solutionTransportPrice.unit
                                            )}
                                        </UppEmpty>
                                      )}
                                    </SolutionListItemPriceValue>
                                  )}
                                  {solutionItem.calculatedUnitPurchasePrice
                                    ?.errors && (
                                    <SolutionListItemPriceValue>
                                      <Image
                                        src={orangeArrowIcon}
                                        className="addd-edit-selling-price__image-small-icon"
                                      />
                                      <UnitPriceInput
                                        type="text"
                                        value={
                                          solutionItem.solution
                                            .unitPurchasePrice?.transport?.price
                                        }
                                        onChange={(e) => {
                                          onSellingPriceSolutionChange(
                                            e,
                                            solutionItem.id,
                                            hesusCatalogServiceId,
                                            hesusServiceId,
                                            "upp",
                                            "transport"
                                          );
                                        }}
                                      />{" "}
                                      {currency +
                                        "  /" +
                                        t(serviceData.serviceField.unit.value)}
                                      {solutionItem.solution?.unitPurchasePrice
                                        ?.transport?.error && (
                                        <RequiredMessagePara>
                                          {
                                            solutionItem.solution
                                              ?.unitPurchasePrice?.transport
                                              ?.error
                                          }
                                        </RequiredMessagePara>
                                      )}
                                    </SolutionListItemPriceValue>
                                  )}
                                </>
                              )}
                            {serviceData.hesusServiceInfo.needProduct &&
                              serviceData.hesusServiceInfo.needTransport &&
                              solutionItem.priceType === 1 && (
                                <>
                                  {!solutionItem.calculatedUnitPurchasePrice
                                    ?.errors && (
                                    <SolutionListItemPriceValue color="#008395">
                                      {parseInt(currencyId, 10) ===
                                        parseInt(
                                          solutionItem.solutionTransportPrice
                                            .currency.id,
                                          10
                                        ) &&
                                        !solutionItem
                                          .calculatedUnitPurchasePrice
                                          ?.transportTreatment?.error && (
                                          <>
                                            <Image
                                              src={blueArrowIcon}
                                              className="addd-edit-selling-price__image-small-icon"
                                            />
                                            {renderPriceWithCurrency(
                                              solutionItem
                                                .calculatedUnitPurchasePrice
                                                ?.transportTreatment?.price,
                                              t(
                                                solutionItem
                                                  .calculatedUnitPurchasePrice
                                                  ?.transportTreatment?.unit
                                              ),
                                              currency,
                                              currencyPosition
                                            )}
                                          </>
                                        )}
                                      {parseInt(currencyId, 10) !==
                                        parseInt(
                                          solutionItem.solutionTransportPrice
                                            .currency.id,
                                          10
                                        ) &&
                                        exchangeRate.find(
                                          (rate) =>
                                            rate.id ===
                                              solutionItem
                                                .solutionTransportPrice.currency
                                                .id && rate.rate !== ""
                                        ) && (
                                          <>
                                            <Image
                                              src={blueArrowIcon}
                                              className="addd-edit-selling-price__image-small-icon"
                                            />
                                            {renderPriceWithCurrency(
                                              solutionItem
                                                .calculatedUnitPurchasePrice
                                                ?.transportTreatment?.price,
                                              t(
                                                solutionItem
                                                  .calculatedUnitPurchasePrice
                                                  ?.transportTreatment?.unit
                                              ),
                                              currency,
                                              currencyPosition
                                            )}
                                          </>
                                        )}
                                      {((parseInt(currencyId, 10) !==
                                        parseInt(
                                          solutionItem.solutionTransportPrice
                                            .currency.id,
                                          10
                                        ) &&
                                        !exchangeRate.find(
                                          (rate) =>
                                            rate.id ===
                                              solutionItem
                                                .solutionTransportPrice.currency
                                                .id && rate.rate !== ""
                                        )) ||
                                        solutionItem.calculatedUnitPurchasePrice
                                          ?.transportTreatment?.error) && (
                                        <UppEmpty>
                                          <Image
                                            src={orangeArrowIcon}
                                            className="addd-edit-selling-price__image-small-icon"
                                          />
                                          {"-- " +
                                            currency +
                                            " /" +
                                            t(
                                              solutionItem
                                                .solutionTransportPrice.unit
                                            )}
                                        </UppEmpty>
                                      )}
                                    </SolutionListItemPriceValue>
                                  )}
                                  {solutionItem.calculatedUnitPurchasePrice
                                    ?.errors && (
                                    <SolutionListItemPriceValue>
                                      <Image
                                        src={orangeArrowIcon}
                                        className="addd-edit-selling-price__image-small-icon"
                                      />
                                      <UnitPriceInput
                                        type="text"
                                        value={
                                          solutionItem.solution
                                            ?.unitPurchasePrice
                                            ?.transportTreatment?.price
                                        }
                                        onChange={(e) => {
                                          onSellingPriceSolutionChange(
                                            e,
                                            solutionItem.id,
                                            hesusCatalogServiceId,
                                            hesusServiceId,
                                            "upp",
                                            "transportTreatment"
                                          );
                                        }}
                                      />{" "}
                                      {currency +
                                        "  /" +
                                        t(serviceData.serviceField.unit.value)}
                                      {solutionItem.solution?.unitPurchasePrice
                                        ?.transportTreatment?.error && (
                                        <RequiredMessagePara>
                                          {
                                            solutionItem.solution
                                              ?.unitPurchasePrice
                                              ?.transportTreatment?.error
                                          }
                                        </RequiredMessagePara>
                                      )}
                                    </SolutionListItemPriceValue>
                                  )}
                                </>
                              )}
                          </SolutionListItemPrice>
                        </SolutionListItemPriceWrapper>
                      )}

                      {solutionItem.priceType ===
                        priceTypes.TransportTreatment && (
                        <SolutionListItemPriceWrapper>
                          <SolutionListItemPrice>
                            <SolutionListItemPriceLabel
                              color={colorOfBox(
                                "TRANSPORT",
                                serviceData.hesusServiceInfo
                              )}
                            >
                              {t("TREATMENT_TRANSPORT_PRICE")} -{" "}
                              <SolutionListItemPriceValue fontStyle="italic">
                                {
                                  solutionItem.solutionTransportPrice
                                    ?.transportType?.name
                                }
                              </SolutionListItemPriceValue>
                            </SolutionListItemPriceLabel>
                            <SolutionListItemPriceValue
                              textAlign="right"
                              color={colorOfBox(
                                "TRANSPORT",
                                serviceData.hesusServiceInfo
                              )}
                            >
                              {renderPriceWithCurrency(
                                solutionItem.solutionTransportPrice?.price ??
                                  "",
                                t(solutionItem.solutionTransportPrice.unit),
                                solutionItem.solutionTransportPrice.currency
                                  ?.symbol,
                                solutionItem.solutionTransportPrice.currency
                                  ?.position
                              )}
                            </SolutionListItemPriceValue>
                            {serviceData.hesusServiceInfo.needProduct &&
                              serviceData.hesusServiceInfo.needTransport && (
                                <>
                                  {!solutionItem.calculatedUnitPurchasePrice
                                    ?.errors && (
                                    // new code starts here //
                                    <SolutionListItemPriceValue color="#008395">
                                      {parseInt(currencyId, 10) ===
                                        parseInt(
                                          solutionItem.solutionTransportPrice
                                            .currency.id,
                                          10
                                        ) &&
                                        !solutionItem
                                          .calculatedUnitPurchasePrice
                                          ?.transportTreatment?.error && (
                                          <>
                                            <Image
                                              src={blueArrowIcon}
                                              className="addd-edit-selling-price__image-small-icon"
                                            />
                                            {renderPriceWithCurrency(
                                              solutionItem
                                                .calculatedUnitPurchasePrice
                                                ?.transportTreatment?.price,
                                              t(
                                                solutionItem
                                                  .calculatedUnitPurchasePrice
                                                  ?.transportTreatment?.unit
                                              ),
                                              currency,
                                              currencyPosition
                                            )}
                                          </>
                                        )}
                                      {parseInt(currencyId, 10) !==
                                        parseInt(
                                          solutionItem.solutionTransportPrice
                                            .currency.id,
                                          10
                                        ) &&
                                        exchangeRate.find(
                                          (rate) =>
                                            rate.id ===
                                              solutionItem
                                                .solutionTransportPrice.currency
                                                .id && rate.rate !== ""
                                        ) && (
                                          <>
                                            <Image
                                              src={blueArrowIcon}
                                              className="addd-edit-selling-price__image-small-icon"
                                            />
                                            {renderPriceWithCurrency(
                                              solutionItem
                                                .calculatedUnitPurchasePrice
                                                ?.transportTreatment?.price,
                                              t(
                                                solutionItem
                                                  .calculatedUnitPurchasePrice
                                                  ?.transportTreatment?.unit
                                              ),
                                              currency,
                                              currencyPosition
                                            )}
                                          </>
                                        )}
                                      {((parseInt(currencyId, 10) !==
                                        parseInt(
                                          solutionItem.solutionTransportPrice
                                            .currency.id,
                                          10
                                        ) &&
                                        !exchangeRate.find(
                                          (rate) =>
                                            rate.id ===
                                              solutionItem
                                                .solutionTransportPrice.currency
                                                .id && rate.rate !== ""
                                        )) ||
                                        solutionItem.calculatedUnitPurchasePrice
                                          ?.transportTreatment?.error) && (
                                        <UppEmpty>
                                          <Image
                                            src={orangeArrowIcon}
                                            className="addd-edit-selling-price__image-small-icon"
                                          />
                                          {"-- " +
                                            currency +
                                            " /" +
                                            t(
                                              solutionItem
                                                .solutionTransportPrice.unit
                                            )}
                                        </UppEmpty>
                                      )}
                                    </SolutionListItemPriceValue>
                                  )}
                                  {solutionItem.calculatedUnitPurchasePrice
                                    ?.errors && (
                                    <SolutionListItemPriceValue>
                                      <Image
                                        src={orangeArrowIcon}
                                        className="addd-edit-selling-price__image-small-icon"
                                      />
                                      <UnitPriceInput
                                        type="text"
                                        value={
                                          solutionItem.solution
                                            ?.unitPurchasePrice
                                            ?.transportTreatment?.price
                                        }
                                        onChange={(e) => {
                                          onSellingPriceSolutionChange(
                                            e,
                                            solutionItem.id,
                                            hesusCatalogServiceId,
                                            hesusServiceId,
                                            "upp",
                                            "transportTreatment"
                                          );
                                        }}
                                      />{" "}
                                      <UppEmpty>
                                        {currency +
                                          "  /" +
                                          t(
                                            serviceData.serviceField.unit.value
                                          )}
                                      </UppEmpty>
                                      {solutionItem.solution?.unitPurchasePrice
                                        ?.transportTreatment?.error && (
                                        <RequiredMessagePara>
                                          {
                                            solutionItem.solution
                                              ?.unitPurchasePrice
                                              ?.transportTreatment?.error
                                          }
                                        </RequiredMessagePara>
                                      )}
                                    </SolutionListItemPriceValue>
                                  )}
                                </>
                              )}
                          </SolutionListItemPrice>
                        </SolutionListItemPriceWrapper>
                      )}

                      {!!solutionItem?.solutionTreatmentPrice?.tgap &&
                        solutionItem?.solutionTreatmentPrice?.tgap !== null && (
                          <SolutionListItemPriceWrapper>
                            <SolutionListItemPrice>
                              <SolutionListItemPriceLabel>
                                {t("SOLUTION_LANDFILL_TAX")}
                              </SolutionListItemPriceLabel>
                              <SolutionListItemPriceValue textAlign="right">
                                {renderPriceWithCurrency(
                                  solutionItem?.solutionTreatmentPrice?.tgap,
                                  t("TON"),
                                  solutionItem?.solutionTreatmentPrice?.currency
                                    ?.symbol,
                                  solutionItem?.solutionTreatmentPrice?.currency
                                    ?.position
                                )}
                              </SolutionListItemPriceValue>
                            </SolutionListItemPrice>
                          </SolutionListItemPriceWrapper>
                        )}
                    </div>
                    <AllocationParent>
                      <Dropdown
                        label={t("Allocation")}
                        name={
                          parseInt(hesusCatalogServiceId) +
                          "_" +
                          parseInt(solutionItem.id, 10) +
                          "_" +
                          t("Allocation")
                        }
                        value={solutionItem.solution?.allocation ?? null}
                        defaultOption={t("NONE_SELECTED")}
                        // defaultOption={0}
                        containerStyles={{ width: "150px", lineHeigth: 1 }}
                        inputStyles={{
                          border: "1px solid #474747",
                          height: "30px",
                        }}
                        options={range(0, 110, 10).map((key) => ({
                          label: `${key}%`,
                          value: key,
                        }))}
                        // disabled={isDisabled}
                        disabled={checkDisabledStatausOfAllocation(
                          serviceData.hesusServiceInfo.needProduct,
                          serviceData.hesusServiceInfo.needTransport,
                          serviceData.hesusCatalogServiceCombination
                        )}
                        onChange={(e) => {
                          onSellingPriceSolutionChange(
                            e,
                            solutionItem.id,
                            hesusCatalogServiceId,
                            hesusServiceId,
                            "allocation"
                          );
                        }}
                      />
                      {solutionItem?.isSelected &&
                        serviceData.serviceField.quantity.value &&
                        serviceData.serviceField.unit.value &&
                        (solutionItem.solution?.allocationQuantity ||
                          solutionItem.solution?.allocationQuantity === 0) && (
                          <AllocationQuantity>
                            {solutionItem.solution?.allocationQuantity +
                              " " +
                              t(serviceData.serviceField.unit.value)}
                          </AllocationQuantity>
                        )}
                      {solutionItem?.isSelected &&
                        !serviceData.serviceField.quantity.value &&
                        serviceData.serviceField.unit.value && (
                          <AllocationQuantity>
                            {"? " + t(serviceData.serviceField.unit.value)}
                          </AllocationQuantity>
                        )}
                    </AllocationParent>
                  </GridOuterPriceType>
                  {solutionItem.internalComment && (
                    <GridRow gap="0px" column="auto 1fr">
                      <SolutionListItemTitle fontSize="14px">
                        {t("SOLUTION_VIEW_PURCHASE_PRICE_ASSUMPTION")} :
                      </SolutionListItemTitle>
                      <CommentText
                        id={`selling-price-solution-internal-comment-id-${solutionItem.id}`}
                      >
                        {solutionItem.internalComment}
                      </CommentText>
                      <Tooltip
                        place="top-start"
                        anchorSelect={`#selling-price-solution-internal-comment-id-${solutionItem.id}`}
                        style={DivToolTipCustom}
                      >
                        <ToolTipCommentsWrapper>
                          <GridRow gap="0px" column="1fr">
                            <ToolTipCommentText>
                              {solutionItem?.internalComment}
                            </ToolTipCommentText>
                          </GridRow>
                        </ToolTipCommentsWrapper>
                      </Tooltip>
                    </GridRow>
                  )}
                  {solutionItem.quoteComment && (
                    <GridRow gap="0px" column="auto 1fr">
                      <SolutionListItemTitle fontSize="14px" color="#f08046">
                        {t("SOLUTION_VIEW_SPECIFIC_CONDITIONS_CLIENT")} :
                      </SolutionListItemTitle>
                      <CommentText
                        id={`selling-price-solution-quote-comment-id-${solutionItem.id}`}
                      >
                        {solutionItem.quoteComment}
                      </CommentText>
                      <Tooltip
                        place="top-start"
                        anchorSelect={`#selling-price-solution-quote-comment-id-${solutionItem.id}`}
                        style={DivToolTipCustom}
                      >
                        <ToolTipCommentsWrapper>
                          <GridRow gap="0px" column="1fr">
                            <ToolTipCommentText>
                              {solutionItem?.quoteComment}
                            </ToolTipCommentText>
                          </GridRow>
                        </ToolTipCommentsWrapper>
                      </Tooltip>
                    </GridRow>
                  )}
                </SolutionListItem>
              );
            })}
          {serviceData.serviceField.solutionList.value.length === 0 &&
            countryNeedSolution === 0 &&
            serviceData.hesusServiceInfo.needSolution && (
              <NoSolutionOuter>
                <NoSolution>
                  {t("SELLING_PRICE_SOLUTIONS_NO_SOLUTION")}
                </NoSolution>
                <ToggleGridOuter>
                  <Image
                    src={
                      serviceData.serviceField.estimatedPurchasePriceToggle
                        .value
                        ? enableIcon
                        : disableIcon
                    }
                    alt={t("SELLING_PRICE_FILTER_ACTIVE_ONLY")}
                    title={t("SELLING_PRICE_FILTER_ACTIVE_ONLY")}
                    marginLeft="7px"
                    onClick={onChange}
                    name={
                      serviceData.serviceField.estimatedPurchasePriceToggle.name
                    }
                    id={
                      serviceData.serviceField.estimatedPurchasePriceToggle.name
                    }
                    className="addd-edit-selling-price__image-icon"
                  />
                  <SolutionToggleLabel color="#767676">
                    {t("SELLING_PRICE_SOLUTIONS_NO_SOLUTION_TOGGLE")}
                  </SolutionToggleLabel>
                </ToggleGridOuter>
                {serviceData.serviceField.estimatedPurchasePriceToggle
                  .value && (
                  <>
                    <GridRow marginTop="5px;" column="1fr 1fr 1fr">
                      <PriceContainer>
                        <TextInput
                          type="text"
                          label={t("SELLING_PRICE_SOLUTIONS_AVG_PURCHASE")}
                          name={
                            serviceData.serviceField.estimatedPurchasePrice.name
                          }
                          id={
                            serviceData.serviceField.estimatedPurchasePrice.name
                          }
                          isFloat
                          placeholder={t(
                            "SELLING_PRICE_SOLUTIONS_AVG_PURCHASE"
                          )}
                          value={String(
                            serviceData.serviceField.estimatedPurchasePrice
                              .value
                          )}
                          disabled={isDisabled}
                          required
                          errorStyles={{ "font-style": "italic" }}
                          onChange={onChange}
                          labelStyles={
                            serviceData.serviceField.estimatedPurchasePrice
                              .error !== ""
                              ? labelStylesError
                              : labelStyles
                          }
                          inputStyles={
                            serviceData.serviceField.estimatedPurchasePrice
                              .error !== ""
                              ? inputStylesError
                              : inputStyles
                          }
                          containerStyles={{ marginTop: "21px" }}
                          error={
                            serviceData.serviceField.estimatedPurchasePrice
                              .error
                          }
                        />
                        <PricePerUnit>
                          {serviceData.serviceField.unit.value
                            ? `${currency} / ${t(
                                serviceData.serviceField.unit.value
                              )}`
                            : ""}
                        </PricePerUnit>
                      </PriceContainer>
                    </GridRow>
                    <GridRow marginTop="14px">
                      <NoSolution fontSize="12px">
                        {t("SELLING_PRICE_SOLUTIONS_AVG_PURCHASE_INFORMATION")}
                      </NoSolution>
                    </GridRow>
                  </>
                )}
              </NoSolutionOuter>
            )}
          {serviceData.serviceField.solutionList.value.length === 0 &&
            countryNeedSolution === 1 &&
            serviceData.hesusServiceInfo.needSolution && (
              <NoSolutionOuter>
                <NoSolution>
                  {t("SELLING_PRICE_SOLUTIONS_NO_SOLUTION")}
                </NoSolution>
              </NoSolutionOuter>
            )}
        </SolutionListItemOuter>
      )}
      {serviceData.serviceField.solutionList.value.length > 0 && (
        <GridPurchasePriceType>
          <SolutionListItemPriceLabel
            color={
              serviceData.serviceField?.purchasePrice?.value ||
              serviceData.serviceField?.purchasePrice?.value === 0
                ? "#0A4986"
                : "#E83F1E"
            }
          >
            {t("SELLING_PRICE_PURCHASE_PRICE")}
            {" : "}
            <PurchasePriceValue
              color={
                serviceData.serviceField?.purchasePrice?.value ||
                serviceData.serviceField?.purchasePrice?.value === 0
                  ? "#474747"
                  : "#E83F1E"
              }
            >
              {serviceData.serviceField?.purchasePrice?.value ||
              serviceData.serviceField?.purchasePrice?.value === 0
                ? renderPriceWithCurrency(
                    serviceData.serviceField?.purchasePrice?.value,
                    t(serviceData.serviceField?.unit?.value),
                    currency,
                    currencyPosition
                  )
                : "?"}
            </PurchasePriceValue>
          </SolutionListItemPriceLabel>
          {serviceData.serviceField?.estimatedPurchasePrice?.value && (
            <EstimatedPurchasePriceLabel>
              {" ("}
              {t("SELLING_PRICE_PURCHASE_PRICE_ESTIMATION")}
              {" : "}
              {renderPriceWithCurrency(
                serviceData.serviceField?.estimatedPurchasePrice?.value,
                t(serviceData.serviceField?.unit?.value),
                currency,
                currencyPosition
              )}
              {") "}
            </EstimatedPurchasePriceLabel>
          )}
        </GridPurchasePriceType>
      )}
    </>
  );
};

SolutionListing.propTypes = {
  isEditMode: PropTypes.bool.isRequired,
  id: PropTypes.number,
  isDisabled: PropTypes.bool,
};

SolutionListing.defaultProps = {
  id: null,
  isDisabled: null,
};

export default withTranslation()(SolutionListing);
